import UI from "./base/UI";
import bodymovin from '../libs/lottie.min';
import {callByObserver} from "../functions/simple.ui";

/**
 * Lottie animation
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_lottie.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_lottie.html)
*/
class Lottie extends UI {
    defaults = {
        speed: 1,
        auto: true,
        loop: true,
        destroy: false,
        holdStoptime:undefined,
        holdPlaytime:undefined,
        lottieAni: function(){}
    };
    
    constructor(el, options) {
        super('Lottie', el);

        this.init(el, options);
    }

    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }
        this.render();
    }
    /**
    * 로띠 비동기적으로 불러왔을 경우 update
    * @example 
    *  $('.ui-lottie').data('ui').update();
    */
    update(){
        this.defaults = {...this.defaults, ...this.el.dataset};
        this.destroy();
        this.render();
    }
    render() {
        if (this.$el.find('svg').length > 0 || this.$el.find('canvas').length > 0) {
            return false
        }
        let lottiePath;
        if (this.defaults.path != undefined) {
            lottiePath = `${this.defaults.path}${this.defaults.filename}.json`;
        } else { 
            lottiePath = `/resource/js/mmk/json/${this.defaults.filename}.json`;
        }

        function getBoolean(boolean){
            return boolean === true || boolean === "true";
        }
        
        this.defaults.lottieAni = bodymovin.loadAnimation({
            container: this.$el[0],
            path: lottiePath,
            renderer: this.defaults.render == undefined ? 'svg' : this.defaults.render,
            loop: this.defaults.loop,
            autoplay: this.defaults.auto,
        });

        this.$el.attr('lottie-ing',true) // CHPFMTASK-780
        this.defaults.lottieAni.setSpeed(this.defaults.speed);
        if (this.defaults.loopHold != undefined) { // FETASK-1641  : 루프시 중간에 멈추는 시간 값은 1,2 second로 받아옴 
            this.defaults.lottieAni.onLoopComplete = ()=>{
                let _loopHoldtimer;
                this.defaults.lottieAni.stop()
                this.$el.attr('lottieStop', true)
                if (this.$el.attr('lottieStop') == 'true') {
                    _loopHoldtimer = setTimeout (()=>{
                        this.defaults.lottieAni.play();
                        this.$el.attr('lottieStop' ,false)
                        clearTimeout(_loopHoldtimer)
                    },this.defaults.loopHold * 1000)
                }
            }
        }
        this.defaults.lottieAni.onComplete = () => {
            this.$el.attr('lottie-ing',false) // CHPFMTASK-780
            // FETASK-1231 | lottie 재생완료 후 실행
            if (this.completeCallback && $.isFunction(this.completeCallback)) {
                this.completeCallback();
            }
        }

        if(this.defaults.loaded){
            const params = {target: this.el, showFn: () => {this.play()}, options: {threshold: .5}}
            !this.defaults.auto && callByObserver(params);
        }
    }
    //FETASK-1171 | 230717 추가 신분증 촬영 로띠 콜백 이벤트
    nextStepFn(){
        const $wrap = this.$el.closest('.page-inner-scroll');

        this.$el.hide();
        $wrap.find('.id-card-open').addClass('active');
        $wrap.find('.title-group:first, .id-card-tip.show1:first').hide()
        $wrap.find('.title-group:last, .id-card-tip.show1:last, .id-card-tip.show2').css({'opacity':0,'display':'block'}).animate({
            opacity:1
        },600);
    }

    /**
     * 콜백
     * @param callback    {function}  
     * @example 
     * $('.ui-lottie').data('ui').completeCallbackAction(function(){});
     */
    completeCallbackAction(callback){ // FETASK-1231 | lottie 재생완료 후 실행할 callback
        this.completeCallback = callback;
    }
    /**
     * 로띠 stop
     * @example 
     * $('.ui-lottie').data('ui').stop();
     */
    stop(){
        this.defaults.lottieAni.stop();
        this.$el.attr('lottie-ing',false);
    }
    /**
     * 로띠 play,  play() 이후   <div class="ui-lottie" lottie-ing="true">  속성 추가됨
     * @example 
     * $('.ui-lottie').data('ui').play();
     */
    play(){
        this.defaults.lottieAni.play();
        this.$el.attr('lottie-ing',true)
    }

    /**
     * 로띠 replay,  lottie-ing == 'false' 일때  replay()  실행
     * @example 
     * $('.ui-lottie').data('ui').replay();
     */
    replay(){  //CHPFMTASK-780
        // if (this.$el.attr('lottie-ing') == 'false') {
        //     this.stop();
        //     setTimeout(()=>{
        //         this.play();
        //     },50)
        // }
        
        // CHPFMTASK-2318 로띠 replay 내장 함수로 변경
        if(this.$el.attr('lottie-ing') == 'false'){
            this.defaults.lottieAni.goToAndPlay(0);
            this.$el.attr('lottie-ing',true);
        }
    }
    getDuration(){
        return this.defaults.lottieAni.getDuration();
    }
    destroy(){
        this.defaults.lottieAni.destroy();
    }
}

export default Lottie;
